import {setDisplayName} from 'recompose'

import {wrapDisplayName} from '@jetbrains/teamcity-ui/dist/utils'
import {memo} from 'react'
import type {ComponentType} from 'react'

export const memoWithDisplayName = <P>(component: ComponentType<P>) =>
  setDisplayName(wrapDisplayName(component, 'memo'))(memo(component))
